module.exports = __webpack_public_path__ + "fonts/Archivo-Bold.1eab2d39.ttf";